<ng-container
  *ngIf="{
    isSosh: isSoshFromAbstractAppComponent$ | async,
    isSmartBannerDisplayed: isSmartBannerDisplayed$ | async,
    navConfig: navConfig$ | async,
    isXlScreen: isXlScreen$ | async,
  } as model"
>
  <div [ngClass]="model.isSosh ? 'ecm-theme-sosh' : 'ecm-theme-orange'">
    <ecm-smartbanner *ngIf="model.isSmartBannerDisplayed"></ecm-smartbanner>
    <ecm-service-header
      *ngIf="this.showMenuBar && this.isBrandResolved"
      [isSoshMenu]="this.isSoshMenu"
    ></ecm-service-header>
    <main role="main">
      <ecm-layout-container
        [lateralMenu]="model.navConfig.lateralMenu"
        [carrousel]="model.navConfig.carrousel"
        [isXlScreen]="model.isXlScreen"
      >
        <router-outlet></router-outlet>
      </ecm-layout-container>
    </main>
  </div>
</ng-container>
